<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">公区配套设施</h3>
      <div v-for="item in data" class="mb16">
        <!--<div class="left">{{item.facilitiesTypeName}}</div>-->
        <!--<div class="right">-->
          <!--<Checkbox class="item" v-for="item1 in item.facilitiesVoList" :key="item1.facilitiesTypeCode" v-model="item1.isSelected">{{item1.facilitiesName}}</Checkbox>-->
        <!--</div>-->

        <div class="left">{{item.facilitiesTypeName}}</div>
        <div class="right">
        <table class="ivu-table" cellspacing="0" cellpadding="0" border="0" >
          <thead>
          <tr>
            <th class="ivu-table-column-center">序号</th>
            <th class="ivu-table-column-center width300">名称</th>
            <th class="ivu-table-column-center">显示</th>
          </tr>
          </thead>
          <tbody v-for="item1 in item.facilitiesVoList">
          <tr>
            <td class="ivu-table-column-center"><Input type="text" class="item-width" v-model="item1.sort"s></Input></td>
            <td class="ivu-table-column-center width300">{{item1.facilitiesName}}</td>
            <td class="ivu-table-column-center"><Checkbox class="item"  :key="item1.facilitiesTypeCode" v-model="item1.isSelected"></Checkbox></td>
          </tr>
          </tbody>
        </table>
        </div>

      </div>
    </Modal>
  </div>
</template>

<script>
  import {selectProjectFacilities,saveProjectFacilities} from "../../../../api/projectConfig";
  import {deepClone} from "../../../../utils/format";
  import {isType} from "../../../../utils/public";

  export default {
    name: "PublicConfig",
    props:{
      n: {
        type: Number,
        default: 0
      },
      projectFid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.data=[]
        this.selectProjectFacilities()
        this.isShow=true
      },
    },
    data(){
      return {
        isShow:false,
        data:[],
        loading:true
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
        let ret=[]
        let isNum = false
        var a1=[]
        this.data.forEach(ele=>{
            ele.facilitiesVoList.forEach(ele1=>{
              ele1['fid']=ele1.fid
              ele1['facilitiesTypeCode']=ele.facilitiesTypeCode
              ele1['sort']=ele1.sort
              if(ele1.sort){
                a1.push(ele1.sort+'')
              }
              if((+ele1.sort).toString()==='NaN' || !isType('Number',+ele1.sort)){
                isNum=true
                return
              }else{
                if(ele1.sort && ele1.isSelected &&  ele1.sort <= 0){
                  isNum=true
                  return
                }
              }
              ele1.isSelected && ret.push(ele1)
            })
        })
        if(isNum){
          this.$Message.error('排序必须为数字,且不能小于等于0')
          this.changeLoading()
          return
        }
        var a2=new Set(a1)
        if(a1.length!== a2.size){
          this.$Message.info('排序不能重复')
          this.changeLoading()
          return
        }
        if(ret.length<5){
          this.$Message.info('公区配置数不能为少于5')
          this.changeLoading()
          return
        }
        let params={
          moduleFid:this.projectFid,
          facilitiesTypeDtoList:ret
        }
        saveProjectFacilities(params).then(res=>{
          this.$Message.success("配置成功")
          this.isShow=false
        })
      },
      selectProjectFacilities(){
        if(!this.projectFid){
          return
        }
        let params={
          projectFid:this.projectFid
        }
        selectProjectFacilities(params).then(res=>{
          this.data=res.data
        }).catch(error=>{})
      }
    },

  }
</script>

<style scoped>
  .item{
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .item-width {
    width:50px;
  }
  .left,.right{
    display: inline-block;
    vertical-align: top;
  }
  .left{
    margin-right: 10px;
    width: 60px;
    text-align: right;
  }
  .right{
    width: 300px;
  }
  .width300{
    width: 300px;
  }

</style>
